Promise.allSettled = Promise.allSettled || function (promises) {
  return Promise.all(promises.map(function (p) {
    return p.then(function (v) {
      return {
        status: 'fulfilled',
        value: v
      };
    })["catch"](function (e) {
      return {
        status: 'rejected',
        reason: e
      };
    });
  }));
};
